import type { ScoresWidget } from './ScoresWidget';
import {
    TimelineSlot,
    WidgetType,
    ZodBaseWidgetConfiguration,
    ZodGenericWidgetConfigurationDetails,
} from '../types';
import { z } from 'zod';

export type ScoresWidgetTimelineSlotParams = {
    thisloopcount: number;
    score: ScoresData;
};

export type ScoresWidgetTimelineSlot = TimelineSlot<ScoresWidgetTimelineSlotParams, ScoresWidget>;

//Note -- These are completely unused in Signs
// Instead, the API endpoint grabs the widget metadata from MYSQL
export const ZodScoresWidgetConfigurationDetails = ZodGenericWidgetConfigurationDetails.extend({
    leagues: z.union([z.string(), z.void()]),
    teams: z.union([z.string(), z.void()]),
});

export type ScoresWidgetConfigurationDetails = z.infer<typeof ZodScoresWidgetConfigurationDetails>;

export const ZodScoresWidgetConfiguration = ZodBaseWidgetConfiguration.extend({
    type: z.literal(WidgetType.SCORES),
    config: ZodScoresWidgetConfigurationDetails,
});

export type ScoresWidgetConfiguration = z.infer<typeof ZodScoresWidgetConfiguration>;

export type ScoresData = {
    id: number;
    awaylogo: string; //Url to team logo
    awayscore: unknown; //todo, what type is this prop when present?
    awayteam: string;
    awayteamid: string; //Ex: 'NYM'
    gameid: string | number;
    homelogo: string; //Url to team logo
    homescore: unknown; //todo, what type is this prop when present?
    hometeam: string;
    hometeamid: string; //Ex: 'MIA'
    league: string; //Ex: 'MLB'

    /**
     * Ex: '7:30 pm, ET'
     * Seems like an empty string is also used instead of null
     */
    status: string;
};

export type ScoresTemplateData = {
    wid: string; //widget id
    score: { type: WidgetType.SCORES };
    scores: ScoresData[];
    dimensions: ScoresTemplateSizingData;
    wobj: { widget: { widgetsid: number } };
    Widget: { Id: number };
};

export enum ScoresTemplateLayout {
    LANDSCAPE = 'landscape',
    PORTRAIT = 'portrait',
}

export enum ScoresTemplateSizeTheme {
    XSMALL = 'x-small',
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
}

export type ScoresTemplateSizingData = {
    width: number;
    height: number;
    orientation: ScoresTemplateLayout;
    theme: ScoresTemplateSizeTheme;
    shrinkFactor: boolean;
    topPadding: number;
};
